<template>
<div class="container mb-2" v-if="this.$parent.adsvisible">
    <div id="vwc-container"></div>
</div>
</template>

<script>
export default {
    mounted() {
        this.$ga.screenview('vodafone_ads')
        var order = '5d8b28103d414-373475d04e36612541f56ade2680ca5a5616ab36726360d16fce5ae8a2bfd8b8',
            minHeight = '';

        (function (w, d, s, l, o, h) {
            w[l] = w[l] || [];
            w[l].push({
                'id': o,
                'minHeight': h
            });
            var i = d.getElementsByTagName(s)[0],
                j = d.createElement(s);
            j.async = true;
            j.src = 'https://werbemittel.plus-profi.de/JavaScript/checkout.js';
            i.parentNode.insertBefore(j, i);
        })(window, document, 'script', 'vwc', order, minHeight);
    }
}
</script>

<style>

</style>
